import { gql } from '@apollo/client';
import { JOB_APPLICATION_DETAIL_FIELDS } from '../../fragments';
import { ApolloClientFunctionProps } from '../../utils';
import { JobApplicationType } from '../../../types';

export const GET_JOB_APPLICATION_BY_ID = gql`
  ${JOB_APPLICATION_DETAIL_FIELDS}
  query GetJobApplicationById($jobApplicationId: ID!) {
    jobApplicationById(jobApplicationId: $jobApplicationId) {
      ...JobApplicationDetailFields
    }
  }
`;

export const GET_JOB_APPLICATIONS = gql`
  ${JOB_APPLICATION_DETAIL_FIELDS}
  query GetJobApplications {
    jobApplications {
      ...JobApplicationDetailFields
    }
  }
`;

export function getJobApplications({ client }: ApolloClientFunctionProps) {
  return client?.watchQuery<{ jobApplications: JobApplicationType[] }>({
    query: GET_JOB_APPLICATIONS,
  });
}
